export const getCallDate = (date: Date): string => {
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};

export const getCallTime = (date: Date) => {
    const callStartTime = date
        .toLocaleTimeString('en-GB', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        })
        .split(' ')[0];

    const callEndTime = new Date(date.getTime() + 30 * 60000)
        .toLocaleTimeString('en-GB', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        })
        .replace(' ', '');

    return `${callStartTime} - ${callEndTime}`;
};
